import { render, staticRenderFns } from "./back-to-top.vue?vue&type=template&id=7aa771b8"
import script from "./back-to-top.vue?vue&type=script&lang=ts"
export * from "./back-to-top.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports